function Index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function Forbidden() {
  return import(
    /* webpackChunkName: "page-forbidden" */ '@/pages/forbidden.vue'
  )
}
function Overview() {
  return import(/* webpackChunkName: "page-overview" */ '@/pages/overview.vue')
}
function Report() {
  return import(/* webpackChunkName: "page-report" */ '@/pages/report.vue')
}
function ReportApkId() {
  return import(
    /* webpackChunkName: "page-report-apk-id" */ '@/pages/report/apk/_id.vue'
  )
}
function ReportLogId() {
  return import(
    /* webpackChunkName: "page-report-log-id" */ '@/pages/report/log/_id.vue'
  )
}
function ApplyIndex() {
  return import(
    /* webpackChunkName: "page-apply-index" */ '@/pages/apply/index.vue'
  )
}
function DetectIndex() {
  return import(
    /* webpackChunkName: "page-detect-index" */ '@/pages/detect/index.vue'
  )
}
function HistoryIndex() {
  return import(
    /* webpackChunkName: "page-history-index" */ '@/pages/history/index.vue'
  )
}
function MonitorIndex() {
  return import(
    /* webpackChunkName: "page-monitor-index" */ '@/pages/monitor/index.vue'
  )
}
function RuleIndex() {
  return import(
    /* webpackChunkName: "page-rule-index" */ '@/pages/rule/index.vue'
  )
}
function WareIndex() {
  return import(
    /* webpackChunkName: "page-ware-index" */ '@/pages/ware/index.vue'
  )
}
function DetectAuto() {
  return import(
    /* webpackChunkName: "page-detect-auto" */ '@/pages/detect/auto.vue'
  )
}
function DetectChecklog() {
  return import(
    /* webpackChunkName: "page-detect-checklog" */ '@/pages/detect/checklog.vue'
  )
}
function DetectChooseType() {
  return import(
    /* webpackChunkName: "page-detect-chooseType" */ '@/pages/detect/chooseType.vue'
  )
}
function DetectInspect() {
  return import(
    /* webpackChunkName: "page-detect-inspect" */ '@/pages/detect/inspect.vue'
  )
}
function DetectLog() {
  return import(
    /* webpackChunkName: "page-detect-log" */ '@/pages/detect/log.vue'
  )
}
function DetectManual() {
  return import(
    /* webpackChunkName: "page-detect-manual" */ '@/pages/detect/manual.vue'
  )
}
function DetectManualIndex() {
  return import(
    /* webpackChunkName: "page-detect-manual-index" */ '@/pages/detect/manual/index.vue'
  )
}
function DetectManualId() {
  return import(
    /* webpackChunkName: "page-detect-manual-id" */ '@/pages/detect/manual/_id.vue'
  )
}
function HistoryAPKlog() {
  return import(
    /* webpackChunkName: "page-history-APKlog" */ '@/pages/history/APKlog.vue'
  )
}
function HistoryROMlog() {
  return import(
    /* webpackChunkName: "page-history-ROMlog" */ '@/pages/history/ROMlog.vue'
  )
}
function HistoryLog() {
  return import(
    /* webpackChunkName: "page-history-log" */ '@/pages/history/log.vue'
  )
}
function HistoryMonitor() {
  return import(
    /* webpackChunkName: "page-history-monitor" */ '@/pages/history/monitor.vue'
  )
}
function HistoryApkIndex() {
  return import(
    /* webpackChunkName: "page-history-apk-index" */ '@/pages/history/apk/index.vue'
  )
}
function WareDefend() {
  return import(
    /* webpackChunkName: "page-ware-defend" */ '@/pages/ware/defend.vue'
  )
}
function WareDeveloper() {
  return import(
    /* webpackChunkName: "page-ware-developer" */ '@/pages/ware/developer.vue'
  )
}
function HistoryApkId() {
  return import(
    /* webpackChunkName: "page-history-apk-id" */ '@/pages/history/apk/_id.vue'
  )
}
function RuleQueryPackageName() {
  return import(
    /* webpackChunkName: "page-rule-query-packageName" */ '@/pages/rule/query/_packageName.vue'
  )
}
function WareOperateAddPackage() {
  return import(
    /* webpackChunkName: "page-ware-operate-addPackage" */ '@/pages/ware/operate/_addPackage.vue'
  )
}
function WareOperatePackageName() {
  return import(
    /* webpackChunkName: "page-ware-operate-packageName" */ '@/pages/ware/operate/_packageName.vue'
  )
}
function AddRuleAddPackageName() {
  return import(
    /* webpackChunkName: "page-addRule-add-packageName" */ '@/pages/addRule/add/_packageName.vue'
  )
}
function AddRuleEditPackageName() {
  return import(
    /* webpackChunkName: "page-addRule-edit-packageName" */ '@/pages/addRule/edit/_packageName.vue'
  )
}
function NoticeNetworkTagId() {
  return import(
    /* webpackChunkName: "page-notice-networkTag-id" */ '@/pages/notice/networkTag/_id.vue'
  )
}
function NoticeNetworkTagPackageName() {
  return import(
    /* webpackChunkName: "page-notice-networkTag-packageName" */ '@/pages/notice/networkTag/_packageName.vue'
  )
}
function MonitorType() {
  return import(
    /* webpackChunkName: "page-monitor-type" */ '@/pages/monitor/_type.vue'
  )
}
function WareId() {
  return import(/* webpackChunkName: "page-ware-id" */ '@/pages/ware/_id.vue')
}
function WarePackageName() {
  return import(
    /* webpackChunkName: "page-ware-packageName" */ '@/pages/ware/_packageName.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: Index
  },
  {
    name: 'forbidden',
    path: 'forbidden',
    component: Forbidden
  },
  {
    name: 'overview',
    path: 'overview',
    component: Overview
  },
  {
    name: 'report',
    path: 'report',
    component: Report,
    children: [
      {
        name: 'report-apk-id',
        path: 'apk/:id?',
        component: ReportApkId
      },
      {
        name: 'report-log-id',
        path: 'log/:id?',
        component: ReportLogId
      }
    ]
  },
  {
    name: 'apply-index',
    path: 'apply',
    component: ApplyIndex
  },
  {
    name: 'detect-index',
    path: 'detect',
    component: DetectIndex
  },
  {
    name: 'history-index',
    path: 'history',
    component: HistoryIndex
  },
  {
    name: 'monitor-index',
    path: 'monitor',
    component: MonitorIndex
  },
  {
    name: 'rule-index',
    path: 'rule',
    component: RuleIndex
  },
  {
    name: 'ware-index',
    path: 'ware',
    component: WareIndex
  },
  {
    name: 'detect-auto',
    path: 'detect/auto',
    component: DetectAuto
  },
  {
    name: 'detect-checklog',
    path: 'detect/checklog',
    component: DetectChecklog
  },
  {
    name: 'detect-chooseType',
    path: 'detect/chooseType',
    component: DetectChooseType
  },
  {
    name: 'detect-inspect',
    path: 'detect/inspect',
    component: DetectInspect
  },
  {
    name: 'detect-log',
    path: 'detect/log',
    component: DetectLog
  },
  {
    path: 'detect/manual',
    component: DetectManual,
    children: [
      {
        name: 'detect-manual-index',
        path: '',
        component: DetectManualIndex
      },
      {
        name: 'detect-manual-id',
        path: ':id?',
        component: DetectManualId
      }
    ]
  },
  {
    name: 'history-APKlog',
    path: 'history/APKlog',
    component: HistoryAPKlog
  },
  {
    name: 'history-ROMlog',
    path: 'history/ROMlog',
    component: HistoryROMlog
  },
  {
    name: 'history-log',
    path: 'history/log',
    component: HistoryLog
  },
  {
    name: 'history-monitor',
    path: 'history/monitor',
    component: HistoryMonitor
  },
  {
    name: 'history-apk-index',
    path: 'history/apk',
    component: HistoryApkIndex
  },
  {
    name: 'ware-defend',
    path: 'ware/defend',
    component: WareDefend
  },
  {
    name: 'ware-developer',
    path: 'ware/developer',
    component: WareDeveloper
  },
  {
    name: 'history-apk-id',
    path: 'history/apk/:id?',
    component: HistoryApkId
  },
  {
    name: 'rule-query-packageName',
    path: 'rule/query/:packageName?',
    component: RuleQueryPackageName
  },
  {
    name: 'ware-operate-addPackage',
    path: 'ware/operate/:addPackage?',
    component: WareOperateAddPackage
  },
  {
    name: 'ware-operate-packageName',
    path: 'ware/operate/:packageName?',
    component: WareOperatePackageName
  },
  {
    name: 'addRule-add-packageName',
    path: 'addRule/add/:packageName?',
    component: AddRuleAddPackageName
  },
  {
    name: 'addRule-edit-packageName',
    path: 'addRule/edit/:packageName?',
    component: AddRuleEditPackageName
  },
  {
    name: 'notice-networkTag-id',
    path: 'notice/networkTag/:id?',
    component: NoticeNetworkTagId
  },
  {
    name: 'notice-networkTag-packageName',
    path: 'notice/networkTag/:packageName?',
    component: NoticeNetworkTagPackageName
  },
  {
    name: 'monitor-type',
    path: 'monitor/:type?',
    component: MonitorType
  },
  {
    name: 'ware-id',
    path: 'ware/:id?',
    component: WareId
  },
  {
    name: 'ware-packageName',
    path: 'ware/:packageName?',
    component: WarePackageName
  }
]
